import { ElementRef, Injectable } from '@angular/core';

import { WindowEventService } from '@frontend/sports/common/core/utils/window-event';
import { Observable, combineLatest, concat, delay, distinctUntilChanged, filter, map, of, pairwise } from 'rxjs';

import { IBetslipState } from '../../../base/store/state';

@Injectable()
export class EditBetAddPicksContainerOffsetProvider {
    constructor(private windowEventService: WindowEventService) {}

    getBottomOffset(betslipState$: Observable<IBetslipState>, picksSelectionContainerGetter: () => ElementRef): Observable<number> {
        const betslipStatePipe = betslipState$.pipe(
            map((state) => state.types.editBet.addPicksState),
            pairwise(),
            filter(([previous, current]) => previous.isVisible || current.isVisible),
            map(([previous, current]) => current),
            distinctUntilChanged(),
        );

        const windowResizePipeWithInitialFakeValue = concat(of(undefined), this.windowEventService.resize.asObservable());

        return combineLatest([betslipStatePipe, windowResizePipeWithInitialFakeValue]).pipe(
            delay(1),
            map(([state]) => {
                if (!state.isVisible) {
                    return 0;
                }

                const nativeElement = picksSelectionContainerGetter().nativeElement as HTMLElement;
                if (!nativeElement) {
                    return 0;
                }

                const clientRect = nativeElement.getBoundingClientRect();

                return clientRect.height;
            }),
            distinctUntilChanged(),
        );
    }
}
